const ArrowIcon = (props) => (
    <svg
        width="7"
        height="13"
        viewBox="0 0 7 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.71047 1.1382C6.32047 0.748203 5.69047 0.748203 5.30047 1.1382L0.710469 5.7282C0.320469 6.1182 0.320469 6.7482 0.710469 7.1382L5.30047 11.7282C5.69047 12.1182 6.32047 12.1182 6.71047 11.7282C7.10047 11.3382 7.10047 10.7082 6.71047 10.3182L2.83047 6.4282L6.71047 2.5482C7.10047 2.1582 7.09047 1.5182 6.71047 1.1382Z"
            fill="currentColor"
        />
    </svg>
);

export default ArrowIcon;
